import autobind from 'core-decorators/lib/autobind';

import PAYMENT_MESSAGE_PROXY from 'widget/constants/payment-message-proxy';


export default class PaymentEvents extends React.Component {

  static propTypes = {
    onSale: React.PropTypes.func,
    onRent: React.PropTypes.func,
    onSubscription: React.PropTypes.func,
    onSubscriptionCancel: React.PropTypes.func,
    onAnyEvent: React.PropTypes.func,
  };

  static defaultProps = {
    onSale: _.noop,
    onRent: _.noop,
    onSubscription: _.noop,
    onSubscriptionCancel: _.noop,
    onAnyEvent: _.noop,
  };

  componentDidMount() {
    window.addEventListener('message', this.handlePaymentProxyMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePaymentProxyMessage, false);
  }

  @autobind
  handlePaymentProxyMessage(event) {
    if (event.origin !== window.location.origin) {
      return;
    }
    if (event.data.id !== PAYMENT_MESSAGE_PROXY.ID) {
      return;
    }

    const paymentMessage = event.data.message;
    const handler = {
      [PAYMENT_MESSAGE_PROXY.TYPES.SALE]: this.handleSale,
      [PAYMENT_MESSAGE_PROXY.TYPES.RENT]: this.handleRent,
      [PAYMENT_MESSAGE_PROXY.TYPES.SUBSCRIPTION]: this.handleSubscription,
      [PAYMENT_MESSAGE_PROXY.TYPES.SUBSCRIPTION_CANCEL]: this.handleSubscriptionCancel,
    }[paymentMessage.type];

    if (handler) {
      handler(paymentMessage);
    }
  }

  @autobind
  handleSale(message) {
    const { onSale, onAnyEvent } = this.props;
    if (message.completed) {
      onAnyEvent(message);
      onSale(message);
    }
  }

  @autobind
  handleRent(message) {
    const { onRent, onAnyEvent } = this.props;
    if (message.completed) {
      onAnyEvent(message);
      onRent(message);
    }
  }

  @autobind
  handleSubscription(message) {
    const { onSubscription, onAnyEvent } = this.props;
    if (message.completed) {
      onAnyEvent(message);
      onSubscription(message);
    }
  }

  @autobind
  handleSubscriptionCancel(message) {
    const { onSubscriptionCancel, onAnyEvent } = this.props;
    if (message.completed) {
      onAnyEvent(message);
      onSubscriptionCancel(message);
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/payment-events/payment-events.js